<template>
  <div class="grid grid-cols-2 col-gap-12 row-gap-12">
    <BaseInput class="col-start-1"
               v-model="name"
               :label="$t('nameLabel')"
               :class="{'--error':$v.name.$error }">
      <template #errors>
        <div class="error" v-if="!$v.name.required">{{ $t('errors.required') }}</div>
      </template>
    </BaseInput>
    <BaseButton class="col-start-1 lg:w-91"
                theme="red"
                :loading="submitted"
                @click="createAPIToken">
      {{ $t('createNewToken') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import {mapActions} from "vuex";
import {required} from "vuelidate/lib/validators";

export default {
  name: "CreateAPISession",
  components: {BaseInput, BaseButton},
  data() {
    return {
      name: '',
      submitted: false
    }
  },
  validations: {
    name: {
      required
    },
  },
  methods: {
    ...mapActions('space/apiTokens', ['createNewAPIToken']),
    clearForm() {
      this.name = '';
      this.$v.$reset();
    },
    async createAPIToken() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.submitted) {
        this.submitted = true;
        try {
          const data = {name: this.name},
              res = await this.createNewAPIToken(data);
          if (res.body.success) {
            this.$emit('token-created', res.body.data)
            this.clearForm();
          } else {
            this.$toasted.error(this.$t('errors.response'))
          }
        } catch (err) {
          this.$toasted.error(this.$t('errors.response'))
        } finally {
          this.submitted = false;
        }
      }
    },
  },
  i18n: {
    messages: {
      en: {
        nameLabel: 'Name',
        createNewToken: 'Create token'
      },
      ru: {
        nameLabel: 'Название',
        createNewToken: 'Создать токен'
      }
    }
  }
}
</script>

<style scoped>

</style>